import React from "react"
import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Lightbox from "yet-another-react-lightbox"
import Captions from "yet-another-react-lightbox/plugins/captions"
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails"

import "yet-another-react-lightbox/styles.css"
import "yet-another-react-lightbox/plugins/captions.css"
import "yet-another-react-lightbox/plugins/thumbnails.css"
import { htmlToJsx } from "@src/components/core-value-html"
import { ImageCreditsPropTypes } from "@src/components/core-image"

function getTextOrLink(text, link) {
  return link
    ? `<a href="${link}" target="_blank" rel="nofollow">${text}</a>`
    : text
}
function renderCaption(image) {
  if (!image) {
    return null
  }
  let caption = ""
  let titleSourceLine = ""
  let extraTextLine = ""
  if (image.alt && (!image.credits || !image.credits.titleText)) {
    titleSourceLine = getTextOrLink(
      image.alt,
      image.credits && image.credits.sourceLink,
    )
  }
  if (image.credits) {
    if (image.credits.titleText) {
      titleSourceLine = getTextOrLink(
        image.credits.titleText,
        image.credits.sourceLink,
      )
    }
    if (image.credits.creatorText) {
      titleSourceLine += `${titleSourceLine ? " by " : ""}${getTextOrLink(
        image.credits.creatorText,
        image.credits.creatorLink,
      )}`
    }
    if (image.credits.licenseText) {
      titleSourceLine += `${titleSourceLine ? ", " : ""}${getTextOrLink(
        image.credits.licenseText,
        image.credits.licenseLink,
      )}`
    }
    if (image.credits.extraText) {
      extraTextLine = image.credits.extraText
    }
  }
  if (titleSourceLine) {
    caption += `${caption ? "<br/>" : ""}${titleSourceLine}`
  }
  if (extraTextLine) {
    caption += `${caption ? "<br/>" : ""}${extraTextLine}`
  }
  return caption ? htmlToJsx(caption) : null
}

const StyledLightbox = styled(Lightbox)`
  .yarl__slide_description {
    text-align: center;
  }
`

const ImageGallery = ({
  images,
  activeIndex: initActiveIndex,
  variant,
  toggleButton,
  open: initOpen,
  onClose,
}) => {
  const [isOpen, setIsOpen] = useState(initOpen)

  // Required to toggle gallery state if no button prop is included
  useEffect(() => {
    setIsOpen(initOpen)
  }, [initOpen])

  const formatImages = images.map(image => {
    return {
      ...image,
      description: renderCaption(image),
      alt: undefined,
    }
  })

  if (images.length >= 1 && variant === "popup") {
    return (
      <>
        {toggleButton &&
          React.cloneElement(toggleButton, { onClick: () => setIsOpen(true) })}
        <StyledLightbox
          styles={{ container: { backgroundColor: "rgba(0, 0, 0, .8)" } }}
          open={isOpen}
          index={initActiveIndex || 0}
          slides={[...formatImages]}
          plugins={[Captions, Thumbnails]}
          close={() => {
            setIsOpen(false)
            if (onClose) {
              onClose()
            }
          }}
        />
      </>
    )
  }
  return null
}

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      credits: PropTypes.shape({ ...ImageCreditsPropTypes }),
    }),
  ),
  activeIndex: PropTypes.number,
  variant: PropTypes.oneOf(["popup"]),
  toggleButton: PropTypes.node,
  open: PropTypes.bool,
  onClose: PropTypes.func,
}
export default ImageGallery
